import { deleteArticle } from "shadow-client/endpoints/saleApi";
import { getCart } from "app/redux/selectors";
import { getCartArticleIds, removeCartArticle } from "../modules/cart";

const clearArticleCart = () => (dispatch, getState) => {
  const articleIds = getCartArticleIds(getCart(getState()));
  const articlePromiseList = articleIds.map(articleId =>
    Promise.all([dispatch(deleteArticle(articleId)), dispatch(removeCartArticle(articleId))])
  );

  return Promise.all(articlePromiseList);
};

export default clearArticleCart;



// WEBPACK FOOTER //
// ./src/app/redux/actions/clearArticleCart.js